import light from '@r1-frontend/ui-kit/themes/colors/light';
import { TTheme } from '@r1-frontend/ui-kit/themes/types';

import baseTheme from './theme.common';

const lightTheme: TTheme = {
    ...baseTheme,
    colors: light,
};

export default lightTheme;
